import {Component, DataStore, Record} from "js-data"
import {DateUtils} from "../Basic/Dates"
import {IDateRange} from "../PA.Core.IF.Basic"
import * as _ from "lodash"
import {TextUtils} from "../Basic/Text";

export function getHasOneProperty(obj:any, property_name: string): any {
  if (!(property_name in obj)) {
    return undefined;
  }
  if (!obj[property_name]) {
    return undefined;
  }
  //if (obj[property_name].length == 0) {
  //    return (undefined)
  //}
  return (obj[property_name])
}

export function setHasOneProperty(obj: any, property_name: string, value: any): void {
  if(!(property_name in obj)) {
    return
  }
  if (!obj[property_name]) {
    return
  }


  if(obj[property_name] !== value)
    obj[property_name] = value
}

export function getBelongsToProperty(obj: any, property_name: string) : any {
  if (!(property_name in obj)) {
    return undefined
  }
  if (!obj[property_name]) {
    return undefined
  }

  if (_.isEmpty(obj[property_name])) {
    return undefined
  }


  return obj[property_name]
}

export function setBelongsToProperty(obj: any, property_name: string, value: any): void {
  if(!(property_name in obj)){
    return;
  }

  if(obj[property_name] !== value)
    obj[property_name] = value;

}

export function getHasManyProperty(obj: any, property_name: string) : any {
  if (!(property_name in obj)) {
    return []
  }
  if (!obj[property_name]) {
    return []
  }
  var value = obj[property_name]
  if (_.isArray(value)) {
    return value
  }  else {
    return [value]
  }
}

export function getReferenceToProperty(obj: Record, mapperName: string, foreignKey: string, property_name: string) : any {
  var objany: any = obj
  var objPropertyValue = undefined
  var fk : string | number = objany[foreignKey]

  if ((property_name in obj)) {
    // See if value exists

    objPropertyValue = objany[property_name]
    if (objPropertyValue) {
      // Check if foreign key's match
      if (fk && fk != objPropertyValue[objPropertyValue._mapper().idAttribute]) {
        // value is stale..., foreign key doesn't match..
      } else {
        return objPropertyValue
      }
    }
  }

  // try to get the value from the mapper
  var ds : DataStore = (<any> obj._mapper()).datastore
  if(ds && fk) {
    objPropertyValue = ds.get(mapperName, fk )
    objany[property_name] = objPropertyValue
    return objPropertyValue
  } else {
    return undefined
  }
}


export function setJSONProperty(aRecord: any, sEmitPropertyName: string, property_name: string, newValue: any, bFormat?: boolean): void {

  let writeValue: string = ""

  switch(true) {
    case _.isEmpty(newValue):
      writeValue = "{}"
      break;

    case _.isString(newValue):
      try {
        let testParse = JSON.parse(newValue)
        writeValue = newValue   // Use source formatting
      } catch(err) {
        console.log("Unable to parse object property: ", sEmitPropertyName, " val: ", newValue)
        writeValue = "{}"
      }
      break;

    case _.isPlainObject(newValue):
      if(bFormat)
        writeValue = JSON.stringify(newValue, null,'\t')
      else
        writeValue = JSON.stringify(newValue)
      break;

    default:
      writeValue = "{}"
      break;
  }

  (<any> aRecord)[property_name] = writeValue


  aRecord.emit('change:' + sEmitPropertyName, aRecord, newValue)

}

export function getJSONProperty(aRecord: any, property_name: string, default_value?: object): object {

  if(!(property_name in aRecord)){
    return default_value || {};
  }

  //--
  let sValue = aRecord[property_name]

  try {
    let jsonObj = JSON.parse(sValue)
    return jsonObj
  } catch (err) {
    return default_value || {}
  }

}

//<editor-fold desc="SAP BW Date Only Property helpers">

export function getBWDateProperty(aRecord: any, property_name: string) : Date {
  if (!(property_name in aRecord)) {
    return undefined
  }
  if (!aRecord[property_name]) {
    return undefined
  }
  return  DateUtils.convertFromSAPBW(aRecord[property_name])
}

export function setBWDateProperty(aRecord: Record, sEmitPropertyName: string,  property_name: string, value: Date): void {
  if(!(property_name in aRecord)){
    return;
  }
  var aRow: any = aRecord
  aRow[property_name] = DateUtils.convertToSAPBW(value);
  // Emit the field change
  aRecord.emit('change:' + sEmitPropertyName, aRecord, value)
}
//</editor-fold>

//<editor-fold desc="SAP BW Date Ts number Property helpers">

export function getBWDateTsProperty(aRecord: any, property_name: string) : Date {
  if (!(property_name in aRecord)) {
    return undefined
  }
  if (!aRecord[property_name]) {
    return undefined
  }
  return  DateUtils.convertFromSAPBWTs(aRecord[property_name])
}

export function setBWDateTsProperty(aRecord: Record, sEmitPropertyName: string,  property_name: string, value: Date): void {
  if(!(property_name in aRecord)){
    return;
  }
  var aRow: any = aRecord
  aRow[property_name] = DateUtils.convertToSAPBWTs(value);
  // Emit both the field change
  aRecord.emit('change:' + sEmitPropertyName, aRecord, value)

}

//</editor-fold>

//<editor-fold desc="SAP BW Date Ts (Split String)  Property helpers">

export function getBWDateTsSplitProperty(aRecord: any, date_property_name: string, time_property_name: string) : Date {

  if (!(date_property_name in aRecord)) {
    return undefined
  }

  if (!(time_property_name in aRecord)) {
    return undefined
  }

  if (!aRecord[date_property_name]) {
    return undefined
  }

  if (!aRecord[time_property_name]) {
    return undefined
  }

  return  DateUtils.convertFromSAPBWDateTimeSplit (aRecord[date_property_name], aRecord[time_property_name])

}

export function setBWDateTsSplitProperty(aRecord: Record, sEmitPropertyName: string,  date_property_name: string, time_property_name: string, value: Date): void {
  if(!(date_property_name in aRecord)){
    return;
  }

  if(!(time_property_name in aRecord)){
    return;
  }

  let aRow: any = aRecord
  let aSplitDtTm = DateUtils.convertToSAPBWDateTimeSplit(value)
  aRow[date_property_name] = aSplitDtTm.Dt
  aRow[time_property_name] = aSplitDtTm.Tm

  // Emit the field change
  aRecord.emit('change:' + sEmitPropertyName, aRecord, value)

}


//</editor-fold>




export function getBooleanIndicator(aRecord: Record, property_name: string, unknownIndValue?: boolean): boolean {

  if(!(property_name in aRecord)){
    return undefined;
  }

  let ind_value = (<any> aRecord)[property_name]

  switch(true){
    case _.includes(['1','Y','y','X','x'], ind_value):
      return true;
    case _.includes(['0','N','n'], ind_value):
      return false;
  }

  if(_.isUndefined(unknownIndValue)){ return false }

  return unknownIndValue

}

export function setBooleanIndicator(aRecord: Record, sEmitPropertyName: string, property_name: string, newValue: boolean){

  if(!(property_name in aRecord)){
    return;
  }

  if(newValue){
    (<any> aRecord)[property_name] = '1'
  } else {
    (<any> aRecord)[property_name] = '0'
  }

  aRecord.emit('change:' + sEmitPropertyName, aRecord, newValue)

}


export class DateRangePropertyBW  {

  _record: Record;
  _startColName: string
  _endColName: string
  _emitPropertyName: string

  constructor(aRecord: Record, sEmitPropertyName:string, StartFieldName: string, EndFieldName: string ) {
    this._record = aRecord
    this._emitPropertyName = sEmitPropertyName
    this._startColName = StartFieldName
    this._endColName = EndFieldName
  }

  get Range(): IDateRange {
    return {StartDt: DateUtils.convertFromSAPBW((<any> this._record)[this._startColName]),
      EndDt: DateUtils.convertFromSAPBW((<any> this._record)[this._endColName])}
  }

  set Range(value: IDateRange) {
    if(!value) {
      value = {StartDt:undefined, EndDt: undefined }
    }

    var sBWStart = DateUtils.convertToSAPBW(value.StartDt)
    var sBWEnd = DateUtils.convertToSAPBW(value.EndDt)
    var rec: any = this._record
    rec[this._startColName] =  sBWStart
    rec[this._endColName]= sBWEnd

    this._record.emit('change:' + this._emitPropertyName, this._record,  value)
    this._record.emit('change', this._record, {changed: {[this._emitPropertyName]: value }})

  }

}

export function getDateStringFormat(aRecord: any, date_property_name: string, time_property_name: string) : string {

  if (!(date_property_name in aRecord)) {
    return undefined
  }

  if (!aRecord[date_property_name]) {
    return undefined
  }

  return  DateUtils.convertFromSAPBWDateToString (aRecord[date_property_name], aRecord[time_property_name])

}


export function getTimeStringFormat(aRecord: any, time_property_name: string, date_property_name: string, bIncludeSeconds?: boolean) : string {

  const convertedDates = getBWDateTsSplitProperty(aRecord, time_property_name, date_property_name)
  if (!convertedDates) {
      return ""
  }
  const hrs = convertedDates.getHours() % 12
  const mins = convertedDates.getMinutes().toString().padStart(2, "0");
  const secs = convertedDates.getSeconds().toString().padStart(2, "0");
  const ampm = convertedDates.getHours() >= 12 ? 'PM' : 'AM'
  return `${hrs}:${mins}${bIncludeSeconds ? `:${secs}`: ""} ${ampm}`
}


